import React from 'react';
import icons from '../utils/icons.json';

function Loading() {
	return <div className='waiting' dangerouslySetInnerHTML={{ __html: icons.spinner }}></div>;
}

export default React.memo(Loading);
